import api from "./axios";

export interface CompanyContactDto {
  id?: number;
  name: string;
  phone: string;
  email: string;
  position: string;
  isMain: boolean;
}

export interface CompanyRequisitesDto {
  id?: number;
  addressLegal: string;
  addressActual: string;
  bankName: string;
  bankBik: string;
  bankAccount: string;
  kbe: string;
}

export interface CompanyDto {
  id: number;
  name: string;
  bin: string;
  phone: string;
  email: string;
  director: string;
  roles: string[];
  contacts: CompanyContactDto[];
  requisites?: CompanyRequisitesDto | null;
  openingBalance?: number;
  openingBalanceDate?: string;
}

export interface CompanyPaymentDto {
  id: number;
  companyId: number;
  date: string;
  amount: number;
  type: "in" | "out";
  description: string;
  dealId?: number;
  createdAt: string;
}

export interface ReconciliationRow {
  id: string;
  date: string;
  description: string;
  debit: number;
  credit: number;
  balance: number;
  dealId?: number;
  paymentId?: number;
}

export interface ReconciliationDto {
  openingBalance: number;
  openingBalanceDate: string | null;
  rows: ReconciliationRow[];
  finalBalance: number;
}

function mapToBackend(payload: Partial<CompanyDto>) {
  return {
    name: payload.name,
    bin: payload.bin,
    phone: payload.phone,
    email: payload.email,
    director: payload.director,
    roles: payload.roles,
    contacts: payload.contacts,
    openingBalance: payload.openingBalance,
    openingBalanceDate: payload.openingBalanceDate,
  };
}

export async function getCompanies(): Promise<CompanyDto[]> {
  const res = await api.get("/companies");
  return res.data;
}

export async function createCompany(payload: Partial<CompanyDto>) {
  const dto = mapToBackend(payload);
  const res = await api.post("/companies", dto);
  return res.data;
}

export async function updateCompany(id: number, payload: Partial<CompanyDto>) {
  const dto = mapToBackend(payload);
  const res = await api.put(`/companies/${id}`, dto);
  return res.data;
}

export async function getCompanyRequisites(companyId: number) {
  const res = await api.get(`/companies/${companyId}/requisites`);
  return res.data;
}

export async function saveCompanyRequisites(
  companyId: number,
  payload: Partial<CompanyRequisitesDto>
) {
  const res = await api.put(`/companies/${companyId}/requisites`, payload);
  return res.data;
}

// ─── Платежи ─────────────────────────────────────────────────

export async function getCompanyPayments(companyId: number): Promise<CompanyPaymentDto[]> {
  const res = await api.get(`/companies/${companyId}/payments`);
  return res.data;
}

export async function addCompanyPayment(
  companyId: number,
  payload: { date: string; amount: number; type: "in" | "out"; description?: string; dealId?: number }
): Promise<CompanyPaymentDto> {
  const res = await api.post(`/companies/${companyId}/payments`, payload);
  return res.data;
}

export async function deleteCompanyPayment(companyId: number, paymentId: number): Promise<void> {
  await api.delete(`/companies/${companyId}/payments/${paymentId}`);
}

// ─── Акт сверки ──────────────────────────────────────────────

export async function getReconciliation(companyId: number): Promise<ReconciliationDto> {
  const res = await api.get(`/companies/${companyId}/reconciliation`);
  return res.data;
}

export async function deleteCompany(id: number): Promise<void> {
  await api.delete(`/companies/${id}`);
}
